// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconClass[data-v-1510ae09] {\n  width: 20px;\n  height: 20px;\n}", ""]);
// Exports
module.exports = exports;
